import React from 'react';
import { TrendingDownIcon, ClockIcon, BanknoteIcon, BatteryLowIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { problems } from '../data/content';
const icons = [TrendingDownIcon, ClockIcon, BanknoteIcon, BatteryLowIcon];
export function ProblemSection() {
  return <section className="w-full bg-navy-800 py-20 lg:py-24" aria-labelledby="problem-heading" style={{
    paddingTop: "12px",
    paddingBottom: "12px"
  }} data-id="element-130" data-mp="2vqr69zq2hz5k">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-131" data-mp="39gb6axs9kib6">
        <Reveal className="max-w-3xl" data-id="element-132" data-mp="35gtxpvhjj51s">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-133" data-mp="35fr8drzv9anz">The hard truth</p>
          <h2 id="problem-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-134" data-mp="3jfjxjivqvitu">
            Why traditional real estate methods are now dead
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-135" data-mp="1p454as3iz19c">
            The agents taking your listings aren&rsquo;t working harder. They&rsquo;re running a different operating
            system — and the gap compounds every quarter you wait.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-136" data-mp="ocpxookgtbw0">
          {problems.map((problem, i) => {
          const Icon = icons[i];
          return <Reveal key={problem.stat} delay={i * 0.05} className="h-full" data-id="element-137" data-mp="x6cvek88gp7u" data-mpi={i}>
                <div className="flex h-full flex-col bg-navy-900 p-7" style={{
              paddingTop: "7px",
              paddingBottom: "7px"
            }} data-id="element-138" data-mp="123d1uw8zvtzh">
                  <Icon aria-hidden="true" className="h-7 w-7 text-brand-gold" strokeWidth={1.75} data-id="element-139" data-mp="1c1ss6x076z7x" />
                  <p className="mt-6 text-3xl font-black tracking-tight text-white" style={{
                marginTop: "2px",
                marginBottom: "2px"
              }} data-id="element-140" data-mp="1g3dz81q1wja7">{problem.stat}</p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-141" data-mp="3duqfkdb7gzlh">{problem.text}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}